/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import color from '../../../constants/color';
import materialUI from '../../../material-UI';
import AutoComplete from '../../autoCompleteCommon';
import {
  MenuItem,
  Input,
} from './styles';

const useStyles = materialUI.makeStyles({
  root: {
    '& fieldset': {
      borderRadius: 40,
    },
  },
  input: {
    color: color.grey9,
  },
});

interface Props {
  value: any;
  onChange: any;
  data: Array<any>;
  isMultiple: boolean;
  label?: string;
  autoComplete?: boolean;
}

const SelectComponent: React.FC<Props> = ({
  data,
  onChange,
  value,
  isMultiple,
  label,
  autoComplete,
}) => (
  <>
    {autoComplete ? (
      <AutoComplete
        value={value || ''}
        label={label || ''}
        data={data}
        limitResult={20}
        onChange={onChange}
      />
    ) : (
      (
        <Input
          fullWidth
          classes={{ root: useStyles().root }}
          select
          value={value}
          variant="outlined"
          name="selecteds"
          id="selecteds"
          label={label}
          inputProps={{ className: useStyles().input }}
          SelectProps={{
            multiple: isMultiple,
            value,
            onChange,
          }}
        >
          {data.map((item) => (
            isMultiple ? <MenuItem value={item}>{item.label}</MenuItem>
              : (
                <MenuItem value={item || item.id || item.value || item.idPerfilAcesso}>
                  {item.label}
                </MenuItem>
              )
          ))}
        </Input>
      )
    )}
  </>
);
export default SelectComponent;
